import { getAppConfig } from '@services/config';

const appConfig = getAppConfig();

export const PRISME_ST = 'portailvente_web_wall';

const prismeCommonConfig = {
    env: process.env.NODE_ENV,
    st: PRISME_ST,
    composant: 'app',
    version: appConfig.version,
    domaine: appConfig.domain,
    sendQueueTimeoutInMs: 2000,
    useAutoInstrumentation: true,
};

export const prismeFrontConfig = {
    ...prismeCommonConfig,
    clientUrlEndpoint: appConfig.prisme.url,
    applicationClientName: 'nextweb-front',
    applicationServerName: 'nextweb-back',
    authorizeUrls: appConfig.prisme.authorizeUrls,
    ignoreErrors: [
        'NEXT_REDIRECT',
        '_AutofillCallbackHandler',
        "Identifier 'b' has already been declared",
        'Identifier "b" has already been declared',
        'redeclaration of const b',
        "Can't create duplicate variable",
        'Piano SDK is loaded twice',
        'Minified React error #418',
        'Minified React error #299',
    ],
    ignoreErrorSources: ['piano.io', 'injectedScript'],
};

export const prismeBackConfig = {
    ...prismeCommonConfig,
    application: 'nextweb-back',
    ignoreUrls: [
        appConfig.assets.partials.url,
        // Skeepers OAuth token endpoint : bypass de l'auto-instrumentation Prisme.
        // Le body est du form-urlencoded (grant_type=...) et @bytel/logger-nextjs fait
        // un JSON.parse inconditionnel sur les bodies sortants (bug lib), ce qui masque
        // les vraies erreurs (ex: ETIMEDOUT vers auth.skeepers.io) par une SyntaxError.
        'auth.skeepers.io',
    ],
};
